import React from 'react';
import PropTypes from 'prop-types';
import ALink from 'tradera-components/alink/alink';
import GtmService from 'static/script/app/ui/google-tagmanager-service';
import { useUrlLocalizer } from 'tradera-lang/translate';

const Tag = ({ color, gaAction, gaCategory, name, onClick, url }) => {
    const { toLocalizedUrl } = useUrlLocalizer();

    return (
        <ALink
            type="button"
            className={`btn btn-xs btn-${color} ml-1 mb-1 text-nowrap`}
            onClick={() => {
                typeof onClick === 'function' && onClick();
                GtmService.trackAction(gaCategory, gaAction, name);
            }}
            href={toLocalizedUrl(url)}
            useLink={true}>
            {name}
        </ALink>
    );
};

Tag.defaultProps = {
    color: 'secondary'
};

Tag.propTypes = {
    color: PropTypes.string,
    name: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    gaAction: PropTypes.string.isRequired,
    gaCategory: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
};

export default Tag;
